export const MenuIconV2 = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 3H3.83333C3.64924 3 3.5 3.14924 3.5 3.33333V6C3.5 6.18409 3.64924 6.33333 3.83333 6.33333H6.5C6.68409 6.33333 6.83333 6.18409 6.83333 6V3.33333C6.83333 3.14924 6.68409 3 6.5 3Z"
        fill="#F7AD3C"
        stroke="#F7AD3C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 9H9.83333C9.64924 9 9.5 9.14924 9.5 9.33333V12C9.5 12.1841 9.64924 12.3333 9.83333 12.3333H12.5C12.6841 12.3333 12.8333 12.1841 12.8333 12V9.33333C12.8333 9.14924 12.6841 9 12.5 9Z"
        fill="#7647EE"
        stroke="#7647EE"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 3H9.83333C9.64924 3 9.5 3.14924 9.5 3.33333V6C9.5 6.18409 9.64924 6.33333 9.83333 6.33333H12.5C12.6841 6.33333 12.8333 6.18409 12.8333 6V3.33333C12.8333 3.14924 12.6841 3 12.5 3Z"
        fill="#19AE57"
        stroke="#19AE57"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 9H3.83333C3.64924 9 3.5 9.14924 3.5 9.33333V12C3.5 12.1841 3.64924 12.3333 3.83333 12.3333H6.5C6.68409 12.3333 6.83333 12.1841 6.83333 12V9.33333C6.83333 9.14924 6.68409 9 6.5 9Z"
        fill="#FD561F"
        stroke="#FD561F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
